import { makeStyles } from "@material-ui/core/styles";
export const useStyles = makeStyles(theme => ({
  responsiveGridContainer: {
    [theme.breakpoints.down("xs")]: {
      height: "80vh!important",
      minHeight: "80vh!important",
      maxHeight: "80vh!important"
    }
  }
}));
